import { render, staticRenderFns } from "./CardButtons.vue?vue&type=template&id=6061dae2&scoped=true&"
import script from "./CardButtons.vue?vue&type=script&lang=js&"
export * from "./CardButtons.vue?vue&type=script&lang=js&"
import style0 from "./CardButtons.vue?vue&type=style&index=0&id=6061dae2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6061dae2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VCardTitle,VIcon,VSpacer})
